import React, { forwardRef } from 'react';
import MUISwipeableDrawer, {
  SwipeableDrawerProps as MUISwipeableDrawerProps,
} from '@material-ui/core/SwipeableDrawer';

interface SwipeableDrawerProps extends MUISwipeableDrawerProps {}

const SwipeableDrawer = forwardRef<HTMLAnchorElement, SwipeableDrawerProps>(
  (props, ref) => {
    const { ...rest } = props;

    return <MUISwipeableDrawer {...rest} ref={ref} />;
  }
);

SwipeableDrawer.displayName = 'SwipeableDrawer';

export default SwipeableDrawer;
